


























import { Vue, Component } from 'vue-property-decorator';
import pkg from '../../package.json';

@Component
export default class TheNavBar extends Vue {
  public $auth!: {
    isAuthenticated: boolean;
    user: object[];
    loginWithRedirect(): null;
    logout(object): null;
  };
  private logo = require('@/assets/logo.png');

  private onRouteClick(route: string): void {
    this.$router.push(`/${route}`).catch(err => console.log(err));
  }

  private login() {
    this.$auth.loginWithRedirect();
  }

  private logout() {
    this.$auth.logout({
      returnTo: window.location.origin
    });
  }
}
